module.exports = __webpack_public_path__ + "img/pertambangan_dan_mineral.9782b608.svg";